/* @flow */

import * as React from 'react'

import CloudinaryResource from '../../../infrastructure/components/CloudinaryResource'
import { createWebshopProductImageTransformations } from './shared'

import { WebshopContext } from '../shared'

import { productPresets } from '../../../infrastructure/providers/cloudinary'

const WebshopProductImage = ({ width, ...props }) => {
  const { brand, webshopDesignSettings } = React.useContext(WebshopContext)

  const transformations = React.useMemo(() => {
    return createWebshopProductImageTransformations(webshopDesignSettings)
  }, [webshopDesignSettings])

  const snappedWidth = React.useMemo(() => {
    const allowed = [
      productPresets.product_search.width * 0.6, // 180px, small screens, e.g. 1024px
      productPresets.product_search.width * 0.85, // 265px, medium screens, e.g. 1366–1440px
      productPresets.product_search.width, // 300px, large screens, e.g. 1920px
      productPresets.product_search.width * 1.5, // 450px, very large screens, e.g. 2560px+
      productPresets.product_search.width * 2, // 600px
    ]

    if (!width) return undefined
    return allowed.find(val => val >= width) ?? allowed[allowed.length - 1]
  }, [width])

  const snappedHeight = React.useMemo(() => {
    if (!snappedWidth) return undefined
    return Math.round(snappedWidth * 1.25)
  }, [snappedWidth])

  const transformationOverrides = React.useMemo(() => {
    const overrides = {}
    if (snappedWidth) overrides.width = snappedWidth
    if (snappedHeight) overrides.height = snappedHeight
    return overrides
  }, [snappedWidth, snappedHeight])

  return (
    <CloudinaryResource
      brandId={brand.id}
      transformations={transformations}
      transformationOverrides={transformationOverrides}
      {...props}
    />
  )
}

export default WebshopProductImage
